import { SET_LIST_EVENT, SET_IS_LOADING, SET_DICTIONARIES } from '../constants/listEvent';

export const setListEvent = (data) => ({
  type: SET_LIST_EVENT,
  payload: data,
});

export const setEventDictionaries = (data) => ({
  type: SET_DICTIONARIES,
  payload: data,
});

export const setIsLoading = (isLoading) => ({
  type: SET_IS_LOADING,
  payload: isLoading,
});
